'use client'
import GestureUnlock from '@/jupiter/components/gesture-unlock/gesture-unlock'
import { Button } from '@nf/ui'
import clsx from 'clsx'
import { jupiterButton } from 'styled-system/recipes'
import { useEffect, useMemo } from 'react'
import { useTranslations } from 'next-intl'
import { GestureSettingSteps, useGestureSetting } from './hook/use-gesture-setting'
import {  ModalHeader, ScrollableModal } from '@/components/widgets/scrollable-modal'
import { gestureSettingModalStyles } from './gesture-setting-modal.style'

export const GestureSettingModal = ({
	isOpen,
	closeModal
}:{
	isOpen: boolean;
	closeModal: () => void;
}) => {
	const t = useTranslations('General');
	const { 
		step,
		isSuccess, 
		errorMessage, 
		checkIsPatternValid,
		initGestureSetting
	} = useGestureSetting();  

	useEffect(() => {
		if (isOpen) {
			initGestureSetting();
		}
	}, [isOpen])

	const resultMessage = useMemo(() => {
		if (isSuccess) {
			return (
				<div 
					data-active
					className={gestureSettingModalStyles.topText}
				>
					{t('lbl_LockMsg_SetPWDSucc')}
				</div>
			);
		}
		if (errorMessage.gestureCode) {
			return (
				<div data-error className={gestureSettingModalStyles.topText}>
					{t(errorMessage.gestureCode)}
				</div>
			);
		}
		if (GestureSettingSteps.Confirm === step) {
			return (
				<div className={gestureSettingModalStyles.topText}>
					{t('lbl_LockMsg_ConfirmPWD')}
				</div>
			);
		}
		return (
			<div className={gestureSettingModalStyles.topText}>
				{t('lbl_LockMsg_SetPWD')}
			</div>
		);
	}, [isSuccess, errorMessage.gestureCode, t, gestureSettingModalStyles.topText, step]);


	return (
		<>
			<ScrollableModal
				isOpen={isOpen}
				closeModal={closeModal}
				className={gestureSettingModalStyles.modalContainer}
				header={
					<ModalHeader
						className={gestureSettingModalStyles.header}
						title={t('lbl_GestureSetup')}
						closeModal={closeModal}
					/>
				}
			>
				<div className={gestureSettingModalStyles.container}>
					{resultMessage}
					<GestureUnlock 
						isDisable={isSuccess}
						type={'setting'}
						checkIsPatternValid={checkIsPatternValid} 
					/>
					<div className={gestureSettingModalStyles.bottom}>
						{isSuccess ?(
							<Button 
								className={clsx(jupiterButton({ size: 'lg' }), gestureSettingModalStyles.submitButton)}
								onClick={closeModal}
							>
								{t('lbl_ok')}
							</Button>
						):null}
					</div>
				</div>
			</ScrollableModal>
		</>
		
	)
}

